import React, { Component } from 'react';
import DateChooseAdd from "./DateChooseAdd";
import { getURL } from '../../backend/Backend';
import { getDatesDisplayValue, sameDay} from '../../backend/UIUtils';
import { sendJson, deleteItem } from '../../backend/Backend';
import { ListGroup,  Button, Col, OverlayTrigger, Tooltip, Row, Form } from 'react-bootstrap';
import '../App.css';
import { translate } from "react-i18next";

function emptyDateChoice() {
    return {
        startDate: new Date(),
        startTime: '',
        eventId: ''
    };
}

class DateChoiceEditList extends Component {
    constructor(props) {
        super(props);
        this.onDelete = this.onDelete.bind(this);
        this.onItemInputChange = this.onItemInputChange.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.closeTermin = this.closeTermin.bind(this);
        this.createTerminSelected = this.createTerminSelected.bind(this);

        this.state = {
            selected: emptyDateChoice(),
            dateChoices: [],
            edit: false,
            createTermin: false
        };
    }


    onAdd(eventDate) {
        sendJson('post', 'dateChoices/', eventDate).then(
            received => {
                if (received) {
                    this.loadDateChoices();
                }
            });
    }

    onDelete(id) {
        deleteItem('dateChoices', id).then(
            received => {
                this.loadDateChoices();
            });
    }

    async componentDidMount() {
        this.loadDateChoices();
    }


    onItemInputChange(event) {
        const { name: fieldName, value: fieldValue } = event.target;
        const newDateChoice = {
            ...this.state.selected,
            [fieldName]: fieldValue
        };

        this.setState({
            selected: newDateChoice
        });
    }

    async loadDateChoices() {
        if (!this.props.eventId) {
            return;
        }
        const response = await fetch(getURL(`dateChoices/event/${this.props.eventId}`));
        const json = await response.json();
        let oldState = this.state;
        this.setState({
            ...oldState,
            dateChoices: json,
            selected: emptyDateChoice(),
            edit: false
        });
    }

    createTerminSelected() {
        let oldState = this.state;
        this.setState(
            {
                ...oldState,
                createTermin: true
            }
        );
    }

    closeTermin() {
        let oldState = this.state;
        this.setState(
            {
                ...oldState,
                createTermin: false
            }
        );
    }

    
    render() {
        const { t } = this.props;
      
        return (<div>
                
                            <Row className="pt-3 pl-1">
                    <Col className="mt-1">
                        <Form.Label>{t("einenOderMehrere")}</Form.Label>
                    </Col>
                    <Col >
                        <Button variant="outline-success" onClick={() => this.createTerminSelected()} className="float-left"><span className="fa fa-plus mr-2"></span>
                            { t("termin")}
                        </Button>
                    </Col>
                </Row>
            {(this.state.dateChoices) ?
                <ListGroup>
                  
                    {this.state.dateChoices.map((dateChoice, i) => {
                        return <div key={i}>
                         
                           
                            <Row className="pt-1 pl-1">
                                <Col lg={6} md={4}>
                                <strong>{
                                  getDatesDisplayValue(dateChoice.startDate, dateChoice.endDate, sameDay(dateChoice.startDate, dateChoice.endDate), 'de')}
                                </strong>
                                </Col>
                                <Col lg={6} md={8}>
                                    <OverlayTrigger key="top" placement="top" overlay={
                                        <Tooltip id={`tooltip-top`}>{t("loeschen")} </Tooltip>}>
                                        <Button variant="outline-danger" onClick={() => this.onDelete(dateChoice.id)}  ><span className="fa fa-trash-alt"></span></Button>
                                    </OverlayTrigger>
                                </Col>
                            </Row>

                            <Row>
                                <Col > <hr></hr></Col>
                            </Row>

                        </div>
                    })}
                </ListGroup>
                :
                ""
            }

            {(this.state.createTermin && !this.props.redirectLink)  ?
                    <div>
                        <Row>
                            <Col>
                                <hr />
                            </Col>
                        </Row>
                        <Row className="mt-2 mb-5">
                            <Col>
                                
                                <DateChooseAdd onAdd={this.onAdd} eventId={this.props.eventId} onClose={this.closeTermin} /> 
                            </Col>
                        </Row>
                    </div>
                    :
                    ''
                }

          
        </div>);
    }
}

export default translate("translations")(DateChoiceEditList);